import React from 'react';
import MsvSelect from '../MsvSelect/MsvSelect';
import { DIECASTS_MAIN_CATEGORY } from '../../constants/dropdownIdPairs';
import {
    DEFAULT_RACE_USED_MAIN_CATEGORY,
    getVaultActiveSubcategories,
    toggleVaultMainCategory,
    VAULT_RACE_USED_BROWSE_CATEGORIES,
} from '../../utils/vaultBrowseCategories';
import './VaultBrowseCategoryNav.css';

/**
 * Marketplace-style category browse: sidebar list on desktop, filter selects in the phone drawer.
 */
const VaultBrowseCategoryNav = ({
    layout = 'sidebar',
    isDiecastsMode = false,
    formData,
    onFormDataChange,
    categories = VAULT_RACE_USED_BROWSE_CATEGORIES,
}) => {
    const data = formData || {};
    const activeMainCategory = isDiecastsMode
        ? DIECASTS_MAIN_CATEGORY
        : (data.mainCategory ?? DEFAULT_RACE_USED_MAIN_CATEGORY);
    const activeSubcategories = getVaultActiveSubcategories(data, isDiecastsMode);
    const browseCategories = Array.isArray(categories) && categories.length > 0
        ? categories
        : VAULT_RACE_USED_BROWSE_CATEGORIES;

    const handleMainCategory = (name) => {
        onFormDataChange?.(toggleVaultMainCategory(data, name, isDiecastsMode));
    };

    const handleSubCategory = (name) => {
        onFormDataChange?.({
            ...data,
            mainCategory: isDiecastsMode ? DIECASTS_MAIN_CATEGORY : data.mainCategory,
            subCategory: name,
            subSubCategory: '',
            subSubSubCategory: '',
        });
    };

    const mainCategoryList = (
        <>
            {browseCategories.map((cat) => (
                <button
                    key={cat.label}
                    type="button"
                    className={`msv-browse-cat-item${activeMainCategory === cat.name ? ' is-active' : ''}`}
                    onClick={() => handleMainCategory(cat.name)}
                >
                    {cat.label}
                </button>
            ))}
        </>
    );

    if (layout === 'filter') {
        return (
            <>
                <MsvSelect
                    id="vault-drawer-category"
                    label="Category"
                    fullWidth
                    value={activeMainCategory}
                    options={browseCategories.map((cat) => ({
                        value: cat.name,
                        label: cat.label,
                    }))}
                    onChange={handleMainCategory}
                />
                {activeSubcategories.length > 0 && (
                    <MsvSelect
                        id="vault-drawer-subcategory"
                        label={isDiecastsMode ? 'Scale / type' : 'Type'}
                        fullWidth
                        value={data.subCategory || ''}
                        options={[
                            { value: '', label: 'Any' },
                            ...activeSubcategories.map((sub) => ({
                                value: sub.name,
                                label: sub.name,
                            })),
                        ]}
                        onChange={handleSubCategory}
                    />
                )}
            </>
        );
    }

    if (layout === 'chips') {
        return (
            <>
                <div className="msv-browse-cat-chips-row" aria-label="Categories">
                    {browseCategories.map((cat) => (
                        <button
                            key={cat.label}
                            type="button"
                            className={`msv-browse-cat-chip${activeMainCategory === cat.name ? ' is-active' : ''}`}
                            onClick={() => handleMainCategory(cat.name)}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>
                {activeSubcategories.length > 0 && (
                    <div className="msv-browse-cat-chips-row msv-browse-cat-chips-sub" aria-label="Subcategories">
                        {activeSubcategories.map((sub) => (
                            <button
                                key={sub.id}
                                type="button"
                                className={`msv-browse-cat-chip${data.subCategory === sub.name ? ' is-active' : ''}`}
                                onClick={() => handleSubCategory(sub.name)}
                            >
                                {sub.name}
                            </button>
                        ))}
                    </div>
                )}
            </>
        );
    }

    return (
        <>
            <p className="msv-browse-sidebar-label">Category</p>
            <nav className="msv-browse-cat-list" aria-label="Categories">
                {mainCategoryList}
            </nav>

            {activeSubcategories.length > 0 && (
                <>
                    <p className="msv-browse-sidebar-label">{isDiecastsMode ? 'Scale / type' : 'Filters'}</p>
                    <nav
                        className={`msv-browse-cat-list${!isDiecastsMode ? ' msv-browse-cat-list-nested' : ''}`}
                        aria-label={isDiecastsMode ? 'Diecast scales' : 'Subcategories'}
                    >
                        {activeSubcategories.map((sub) => (
                            <button
                                key={sub.id}
                                type="button"
                                className={`msv-browse-cat-item${data.subCategory === sub.name ? ' is-active' : ''}`}
                                onClick={() => handleSubCategory(sub.name)}
                            >
                                {sub.name}
                            </button>
                        ))}
                    </nav>
                </>
            )}
        </>
    );
};

export default VaultBrowseCategoryNav;
